import IComponent from "components/commons/IComponent";
import SwitchTabs from "components/commons/SwitchTabs";
import Draw from "@arcgis/core/views/draw/Draw";
import Graphic from "@arcgis/core/Graphic";
import geometryTools from "utils/geometryTools";
import Point from "@arcgis/core/geometry/Point";
import Polyline from "@arcgis/core/geometry/Polyline";
import Polygon from "@arcgis/core/geometry/Polygon";
import IdentifyManager from "components/MapViews/IdentifyManager";

const DRAWTOOL_ICON_SET_CONST = [
  {
    action: "point",
    icon: "icn_graphicsearch_point",
    symbol: {
      type: "simple-marker",
      color: [4, 90, 141],
      size: "8px",
    },
    constr: Point,
  },
  {
    action: "polyline",
    icon: "icn_graphicsearch_line",
    symbol: {
      type: "simple-line",
      color: [4, 90, 141],
      width: 4,
      cap: "round",
      join: "round",
    },
    constr: Polyline,
  },
  {
    action: "polygon",
    icon: "icn_graphicsearch_area",
    symbol: {
      type: "simple-fill",
      color: [4, 90, 141, 0.3],
      width: 4,
      cap: "round",
      join: "round",
    },
    constr: Polygon,
  },
  {
    action: "text",
    icon: "icn_3d_Elevationprofile_draw",
    symbol: {
      type: "text", // autocasts as new TextSymbol()
      color: "white",
      haloColor: "black",
      haloSize: "1px",
      text: "Text here",
      xoffset: 3,
      yoffset: 3,
      font: {
        // autocasts as new Font()
        size: 12,
        family: "Josefin Slab",
        weight: "bold",
      },
    },
  },
  { action: "clear", icon: "icn_tool_cleanall" },
];
const currentElevationInfo = {
  mode: "on-the-ground",
  offset: 0,
  featureExpressionInfo: {
    //expression: "Geometry($feature).z * 10"
  },
  unit: "meters",
};

let temp_glayer = undefined;

class DrawTool extends IComponent {
  arcgisDrawTool = null;
  activedTool = null;
  gLayer = null;
  DRAWTOOL_ICON_SET = [];
  constructor(props) {
    super(props);
    this.arcgisDrawTool = new Draw({
      view: props.mapView,
    });
    this.gLayer = geometryTools.createGraphicsLayerById(
      `DrawTool_Layer_${Date.now()}`,
      props.mapView.map
    );
    this.gLayer.elevationInfo = currentElevationInfo;
    console.log("this.gLayer.elevationInfo", this.gLayer.elevationInfo);
    let excludedList = props.excludedList || {};
    this.DRAWTOOL_ICON_SET = DRAWTOOL_ICON_SET_CONST.reduce((p, c, i) => {
      if (!(c.action in excludedList)) p.push(c);
      return p;
    }, []);
    this.state = {
      activeIndex: -1,
      gLayer: this.gLayer,
      activedTool: undefined,
    };
  }
  componentDidMount() {}
  componentWillUnmount() {
    try {
      this.arcgisDrawTool.reset();
      this.props.mapView.map.remove(this.gLayer);
    } catch {}
  }

  handleButtonClick(index, title) {
    if (this.props.GPTools) {
      if (temp_glayer !== undefined) {
        // if (temp_glayer != this.gLayer) {
        temp_glayer.removeAll();
        temp_glayer = this.gLayer;
        // }
      } else {
        temp_glayer = this.gLayer;
      }
    }
    if (title == "icn_tool_cleanall") {
      this.gLayer.removeAll();
      this.activedTool && this.activedTool.destroy();
      this.props.onDrawComplete();
      this.props.GPTools &&
        this.props.mapUICallback("clearAll", undefined, false);
      this.props.AerialPhoto && this.props.mapView.graphics.removeAll();
      return true;
    } else {
      this.props.GPTools &&
        this.props.mapUICallback("DisableWhenDraw", this.props.GPTools, true);
    }
    let actionItem = this.DRAWTOOL_ICON_SET[index];
    let action = actionItem.action === "text" ? "point" : actionItem.action;
    this.activedTool = this.arcgisDrawTool.create(action);
    // this.setState({ activedTool: this.activedTool });
    this.activedTool.on(
      [
        "vertex-add",
        "vertex-remove",
        "cursor-update",
        "redo",
        "undo",
        "draw-complete",
      ],
      this.updateVertices.bind(this, actionItem)
    );
    IdentifyManager.enableIdentify = false;
    this.setState({
      activeIndex: index,
    });
  }
  activeTool() {
    if (this.activedTool) this.activedTool.destroy();
  }
  updateVertices(type, event) {
    this.createGraphic(type, event);
  }
  async createGraphic(type, event) {
    // console.debug(type, event);
    const view = this.props.mapView;
    const vertices = event.vertices.map((v) => [v[0], v[1], 3]);
    this.gLayer.removeAll();

    let geometryAttrName = type.action == "polyline" ? "paths" : "rings";

    let geometry =
      type.action === "point" || type.action === "text"
        ? new this.DRAWTOOL_ICON_SET[0].constr({
            type: "point",
            x: vertices[0][0],
            y: vertices[0][1],
            spatialReference: view.spatialReference,
          })
        : new this.DRAWTOOL_ICON_SET[this.state.activeIndex].constr({
            type: type.action,
            hasZ: true,
            [geometryAttrName]: vertices,
            spatialReference: view.spatialReference,
          });
    const graphic = new Graphic({
      geometry: geometry,
      symbol: type.symbol,
    });

    this.gLayer.add(graphic);

    if (this.props.AerialPhoto === true) {
      this.props.mapUICallback(this.gLayer);
    }

    if (event.type == "draw-complete") {
      let bufferedGeometry = geometry;
      if (this.props.bufferSize > 0) {
        bufferedGeometry = await geometryTools.buffer(
          geometry,
          this.props.bufferSize
        );
        const bufferedGraphic = new Graphic({
          geometry: bufferedGeometry,
          symbol: this.DRAWTOOL_ICON_SET[2].symbol,
        });
        this.gLayer.add(bufferedGraphic);
      }
      this.setState({ activeTabIndex: -1 });
      IdentifyManager.enableIdentify = true;
      let ruturnValue = await this.props.onDrawComplete(
        bufferedGeometry,
        type.symbol
      );
      if (ruturnValue === true) this.gLayer.removeAll();
      this.setState({ activeIndex: -1 });
    }
  }
  render() {
    return (
      <div>
        <SwitchTabs
          activedTab={this.state.activeIndex}
          isIconTabs={true}
          tabText={this.DRAWTOOL_ICON_SET.map((i) => i.icon)}
          onSwitchTabCallback={(e, t) => this.handleButtonClick(e, t)}
          // GPTools={this.props.GPTools}
        />
      </div>
    );
  }
}

export default DrawTool;
